import * as React from "react";
const SvgFiRrWaveform = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-waveform_svg__a)">
      <path
        fill="#062147"
        d="M15.162 24.01h-.008c-.747-.005-1.347-.539-1.425-1.272l-1.73-15.956-1.728 15.957a1.415 1.415 0 0 1-1.425 1.27h-.008a1.415 1.415 0 0 1-1.43-1.257L5.688 8.94l-1.294 9.845a1.404 1.404 0 0 1-1.346 1.228 1.41 1.41 0 0 1-1.464-1.093L.026 12.227a.998.998 0 1 1 1.947-.453l.848 3.638L4.29 4.228A1.4 1.4 0 0 1 5.704 3h.004a1.4 1.4 0 0 1 1.41 1.241L8.8 17.745l1.784-16.458A1.397 1.397 0 0 1 12 .031c.74 0 1.337.527 1.416 1.255l1.784 16.46 1.682-13.51c.084-.712.678-1.233 1.41-1.236h.004c.73 0 1.325.52 1.414 1.233l1.469 11.178.848-3.638a.996.996 0 0 1 1.2-.747 1 1 0 0 1 .747 1.2l-1.56 6.693a1.41 1.41 0 0 1-1.463 1.093 1.404 1.404 0 0 1-1.346-1.228L18.31 8.94 16.59 22.76c-.085.721-.686 1.248-1.43 1.248z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-waveform_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWaveform;
